import {
  IAdminProgramCodeDetails,
  IAdminProgramCodeEditPayload,
  IAdminProgramCodeFormValues,
} from '@interfaces/adminProgramCodes';

export const convertAdminProgramCodeDetailsIntoFormValues = (
  data: IAdminProgramCodeDetails,
): IAdminProgramCodeFormValues => ({
  name: data.name,
  code: data.code,
  canUseDrugInquiry: data.canUseDrugInquiry,
  canUseDrugSearch: data.canUseDrugSearch,
  canUseSupplementInquiry: data.canUseSupplementInquiry,
  canUseEducation: data.canUseEducation,
  multiLanguage: data.multiLanguage,
  bannedText: data.bannedText,
  notBannedText: data.notBannedText,
  signupEmailHeader: data.signupEmailHeader,
  adminEmailHeader: data.adminEmailHeader,
  headlineText: data.headlineText,
  emailHeader: data.emailHeader,
  athleteRoleGroupId: data.athleteRoleGroupId,
  riskLevels: data.riskLevelDescription,
  drugClasses: data.drugClassDtos,
  medicationNotFoundText: data.medicationNotFoundText || '',
  hasInOutCompBan: data.hasInOutCompBan,
  infoTileText: data.infoTileText || '',
  infoPageTitle: data.infoPageTitle || '',
  infoPageText: data.infoPageText || '',
});

export const convertFormValuesToEditPayload = (
  id: number,
  values: IAdminProgramCodeFormValues,
): IAdminProgramCodeEditPayload => ({
  id,
  name: values.name,
  code: values.code,
  canUseDrugInquiry: values.canUseDrugInquiry,
  canUseDrugSearch: values.canUseDrugSearch,
  canUseSupplementInquiry: values.canUseSupplementInquiry,
  canUseEducation: values.canUseEducation,
  multiLanguage: values.multiLanguage,
  bannedText: values.bannedText,
  notBannedText: values.notBannedText,
  signupEmailHeader: values.signupEmailHeader,
  adminEmailHeader: values.adminEmailHeader,
  headlineText: values.headlineText,
  emailHeader: values.emailHeader,
  athleteRoleGroupId: values.athleteRoleGroupId,
  riskLevelDescriptionDtos: values.riskLevels.map(item => ({
    riskLevelId: item.riskLevelId,
    riskLevelDescriptionId: item.riskLevelDescriptionId,
  })),
  drugClassDtos: values.drugClasses,
  medicationNotFoundText: values.medicationNotFoundText || null,
  hasInOutCompBan: values.hasInOutCompBan,
  infoTileText: values.infoTileText || null,
  infoPageTitle: values.infoPageTitle || null,
  infoPageText: values.infoPageText || null,
});

export const validateForm = (values: IAdminProgramCodeFormValues) => {
  const errors: Partial<Record<keyof IAdminProgramCodeFormValues, string | boolean>> = {};

  if (!values.name) errors.name = true;
  if (!values.code) errors.code = true;
  if (!values.bannedText) errors.bannedText = true;
  if (!values.notBannedText) errors.notBannedText = true;
  if (!values.athleteRoleGroupId) errors.athleteRoleGroupId = true;
  if (values.riskLevels?.length !== 3) errors.riskLevels = true;

  return errors;
};
